function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import * as R from 'unitx/ramda';
import { Text } from "../../../native";
import { useFormContext } from "../FormContext";

const DescriptionField = ({
  description,
  formContext,
  descriptionOptions = {}
}) => {
  const {
    mapping,
    descriptionEnabled
  } = useFormContext(formContext);
  return R.ifElse(R.isNil, R.identity, () => descriptionEnabled ? /*#__PURE__*/React.createElement(Text, _extends({}, mapping.description, {
    style: [mapping.description.style]
  }, descriptionOptions), description) : null)(description);
};

export default DescriptionField;